import dynamic from 'next/dynamic';
import { EditableComponent } from '@adobe/aem-react-editable-components';

const ForceChangePassword = dynamic(() => import('./ForceChangePassword').then(mod => mod.ForceChangePassword));

const ForceChangePasswordConfig = {
  emptyLabel: 'ForceChangePassword',
  isEmpty: false,
  resourceType: `mi-aem-account/components/content/forcechangepassword`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ForceChangePasswordEditable = (props: any) => {
  return (
    <EditableComponent config={ForceChangePasswordConfig} {...props}>
      <ForceChangePassword {...props} />
    </EditableComponent>
  );
};
